import { shortHash } from "./formatters";
import { labelForPolicy, labelForRole } from "./labels";

const DEFAULT_PROCESS_LABELS = {
  RELEASE_INTENT_V0: "Deployment approval request",
  COUNCIL_LIFECYCLE_V0: "Council lifecycle update",
};

const DEFAULT_EVENT_LABELS = {
  PROPOSED: "Action proposed",
  SIGNED: "Approval signed",
  ACTION_SIGNED: "Approval signed",
  APPLIED: "Action applied",
  ACTION_APPLIED: "Action applied",
  CHAIN_POLICY_REGISTERED: "Policy registered on chain",
};

const DEFAULT_GOV_ACTION_LABELS = {
  ADD_GC_MEMBER: "Add council member",
  REMOVE_GC_MEMBER: "Remove council member",
  SET_GC_QUORUM: "Set quorum",
  CREATE_ROLE: "Create role",
  ASSIGN_ROLE: "Assign role",
  REVOKE_AUTHORITY: "Revoke authority",
  CREATE_POLICY: "Create policy",
  ACTIVATE_POLICY: "Activate policy",
  BIND_POLICY: "Bind policy",
  CONFIGURE_INTEGRATION: "Configure integration",
  ENABLE_INTEGRATION: "Enable integration",
  DISABLE_INTEGRATION: "Disable integration",
  CREATE_INTEGRATION_TOKEN: "Create integration token",
  REVOKE_INTEGRATION_TOKEN: "Revoke integration token",
  CONFIGURE_INTEGRATION_TRIGGER: "Configure execution trigger",
  DISABLE_INTEGRATION_TRIGGER: "Disable execution trigger",
};

const toTitle = (value) =>
  String(value || "")
    .toLowerCase()
    .split("_")
    .map((part) => (part ? part[0].toUpperCase() + part.slice(1) : ""))
    .join(" ");

export function humanizeProcessType(type) {
  const key = String(type || "").toUpperCase();
  return DEFAULT_PROCESS_LABELS[key] || "Governance action";
}

export function humanizeEventType(type) {
  const key = String(type || "").toUpperCase();
  return DEFAULT_EVENT_LABELS[key] || "Activity recorded";
}

export function humanizeGovernanceActionType(type) {
  const key = String(type || "").toUpperCase();
  return DEFAULT_GOV_ACTION_LABELS[key] || "Governance action";
}

export function resolveUserLabel({ userId, email, walletAddress }, tenantUsers = []) {
  if (email) return email;
  const match = tenantUsers.find((user) => user?.id === userId);
  if (match) return match.email || match.displayName || "Council member";
  if (walletAddress) return "Council member";
  return "Unknown actor";
}

export function humanizeRoleId(roleId, roles = []) {
  if (!roleId) return "Approver";
  const normalized = String(roleId || "").toUpperCase();
  const match = roles.find((role) => role.id === roleId);
  if (match?.name) return match.name;
  const label = labelForRole(roleId);
  if (!label) return "Approver";
  if (label !== shortHash(roleId)) return label;
  if (normalized.includes("_")) return toTitle(normalized);
  return "Approver";
}

export function humanizePolicyId(policyId, policies = []) {
  if (!policyId) return "Approval policy";
  const match = policies.find((policy) => policy.id === policyId);
  if (match?.name) return match.name;
  const label = labelForPolicy(policyId);
  if (!label) return "Approval policy";
  return label === shortHash(policyId) ? "Approval policy" : label;
}

export function describeApprovalRequirement(requiredRoles = [], roles = []) {
  if (!Array.isArray(requiredRoles) || requiredRoles.length === 0) {
    return "Approval required";
  }
  const labels = requiredRoles.map((roleId) => humanizeRoleId(roleId, roles));
  return `Requires approval from ${labels.join(", ")}`;
}

export function hiddenIdPlaceholder(id) {
  if (!id) return "Unavailable";
  return `ID ${shortHash(id, 6, 4)}`;
}
